/*
 * The additional 
 */
var TECL_TenderAdditionalInformation = {

  // Initialise the page
  Initialise: function () {
    TECL_TenderGeneral.HidePleaseWaitDlg();

    // Create the file upload control
    $("#files").kendoUpload({
      async: {
        saveUrl: baseSiteUrl + "umbraco/Surface/Tender/SaveUploadFile?cacheId=" + $("#cacheId").val(),
        removeUrl: baseSiteUrl + "umbraco/Surface/Tender/RemoveUploadFile?cacheId=" + $("#cacheId").val(),
        autoUpload: true
      },
      complete: TECL_TenderAdditionalInformation.UpdateSummaryBox,
      onSuccess: TECL_TenderAdditionalInformation.UpdateSummaryBox
    });

    window.scrollTo(0, 0);

    // Update the progress bar
    TECL_TenderGeneral.UpdateProgressBar(3);

    TECL_TenderProductsSelection.UpdateProductListHeader();

    $(".defaultQuestionListItem *").click(function (e) {
      e.stopPropagation();
    });

    $(".defaultQuestionListItem").click(function () {
      TECL_TenderAdditionalInformation.UpdateQuestionItemState($(this));
    });

    $(".DefaultTenderQuestionCheckbox").change(function () {
      TECL_TenderAdditionalInformation.UpdateQuestionItemState($(this));
    });

    TECL_TenderGeneral.InitialiseStickySidebar();

    // Custom question box input
    $("body").on("input.addInfo", "#newCustomeQuestionText", function () {
      TECL_TenderAdditionalInformation.UpdateSummaryBox();
    });

    // Add another question
    $("body").on("click.addInfo", "#addAnotherQuestion", function() {
      TECL_TenderAdditionalInformation.AddCustomQuestion();
    });

    // Bubble container input change
    $("body").on("input.addInfo", ".bubble-rating-control .bubble-row .bubble-col input", function () {
      var $input = $(this);
      var $parent = $input.closest(".bubble-row");
      var hadVal = !$parent.find(".bubble-item").hasClass("bubble-disabled");
      var hasVal = $input.val().length > 0;

      // If we have a value, but didn't before
      if (hasVal && !hadVal) {
        $parent.find(".bubble-disabled").removeClass("bubble-disabled");
        $parent.find(".bubble-item[data-bubbleIndex='3']").addClass("bubble-enabled");
      } else if (!hasVal) {
        // If we do not have a value
        $parent.find(".bubble-item").removeClass("bubble-enabled");
        $parent.find(".bubble-item").addClass("bubble-disabled");
        $parent.find(".bubble-descriptor").addClass("bubble-disabled");
      }
      // Update the summary box
      TECL_TenderAdditionalInformation.UpdateSummaryBox();
    });

    // Bubble item click
    $("body").on("click.addInfo", ".bubble-item", function () {
      var $bubbleItem = $(this);
      var $parent = $bubbleItem.closest(".bubble-row");
      var inputHasVal = $parent.find("input").val().length > 0;

      if (inputHasVal) {
        $parent.find(".bubble-item").removeClass("bubble-enabled");
        $bubbleItem.addClass("bubble-enabled");
      }
    });

    // Add new criteria button
    $("body").on("click.addInfo", "#addNewCriteria", function () {

      var $criteriaContainer = $("#awardCriteriaContainer");
      // Determine if there are empty inputs, therefor empty criteria sections
      var hasEmptyCriteria = $criteriaContainer.find("input").filter(function() {
        return !this.value;
      }).length > 0;

      if (!hasEmptyCriteria) {

        var hasFiveCriteria = $criteriaContainer.find(".bubble-row").length >= 5;

        if (!hasFiveCriteria) {

          $criteriaContainer.append($("#blankBubbleControlCont").html());
        } else {

          // Show validation message 
          var $validationMaxMessage = $("#maxFiveCriteriaErrorMessage");
          $validationMaxMessage.removeClass("hidden");

          // Hide message after 7s
          setTimeout(function () {
            $validationMaxMessage.addClass("hidden");
          }, 7000);
        }
      } else {

        // Show validation message
        var $validationEmptyMessage = $("#emptyCriteriaErrorMessage");
        $validationEmptyMessage.removeClass("hidden");

        // Hide message after 7s
        setTimeout(function () {
          $validationEmptyMessage.addClass("hidden");
        }, 7000);
      }
    });
  },

  UpdateQuestionItemState: function (element) {
    if (!$(element).hasClass("defaultQuestionListItem")) {
      element = $(element.parents(".defaultQuestionListItem"));
    } else {
      if (element.find(":checked").length > 0) {
        $(element).find("input").prop("checked", false);
      } else {
        $(element).find("input").prop("checked", true);
      }
    }

    if (element.find(":checked").length > 0) {
      element.addClass("selected");
    } else {
      element.removeClass("selected");
    }
    TECL_TenderAdditionalInformation.UpdateSummaryBox();
  },

  UpdateSummaryBox: function () {
    var suggestedQuestionCount = $(".defaultQuestionListItem.selected").length;
    var fileCount = $(".k-file-success").length;
    var ratingsCount = TECL_TenderAdditionalInformation.GetRatingsCount();

    // Get the custom question count
    var customQuestionCount = $(".customQuestionListItem").length;

    // If there is text in the custom question box, this counts as a question
    if ($("#newCustomeQuestionText").val()) {
      customQuestionCount += 1;
    }

    // Show or hide based on zero/non-zero
    if (suggestedQuestionCount == 0 && customQuestionCount == 0 && fileCount == 0 && ratingsCount == 0) {
      $("#noAdditionalInfoSummary").show();
    } else {
      $("#noAdditionalInfoSummary").hide();
    }

    if (suggestedQuestionCount == 0) {
      $("#suggestedQuestionSummary").fadeOut();
    } else {
      $("#suggestedQuestionSummary").fadeIn();
    }

    if (customQuestionCount == 0) {
      $("#customQuestionSummary").fadeOut();
    } else {
      $("#customQuestionSummary").fadeIn();
    }

    if (fileCount == 0) {
      $("#fileSummary").fadeOut();
    } else {
      $("#fileSummary").fadeIn();
    }

    if (ratingsCount == 0) {
      $("#awardCriterias").fadeOut();
    } else {
      $("#awardCriterias").fadeIn();
    }

    $("#suggestedQuestionCount").text(suggestedQuestionCount);
    $("#customQuestionCount").text(customQuestionCount);
    $("#fileCount").text(fileCount);
    $("#ratingsCount").text(ratingsCount);
  },

  // Add a custom question
  AddCustomQuestion: function () {
    $("#errNoCustQuestionText").addClass("hidden");
    var questionText = $("#newCustomeQuestionText").val();

    if (questionText) {

      if (TECL_Master.AddLock("AddCustomQuestion")) {
        $.ajax({
          url: baseSiteUrl + "umbraco/Surface/Tender/AddCustomQuestion",
          type: "POST",
          data: {
            questionText: questionText
          },
          error: function (exc) {
            TECL_Master.ClearLock("AddCustomQuestion");
          },
          success: function (partialViewHtml) {
            TECL_Master.ClearLock("AddCustomQuestion");
            $("#customQuestionsList").append(partialViewHtml);
            $("#newCustomeQuestionText").val("");
            TECL_TenderAdditionalInformation.UpdateSummaryBox();
          }
        });
      }
    } else {
      $("#errNoCustQuestionText").removeClass("hidden");
    }
  },

  // Delete a custom question
  DeleteCustomQuestion: function (questionControlId) {
    $(".customQuestionListItem[data-customquestioncontrolid='" + questionControlId + "']").remove();
    TECL_TenderAdditionalInformation.UpdateSummaryBox();
  },

  // Get the contents of and show the continue dialog
  ShowContinueDialog: function (launchStageNext) {
    $("#errNoCustQuestionText").addClass("hidden");

    if (TECL_Master.AddLock("TECL_TenderAdditionalInformation.ShowContinueDialog")) {

      // TODO Shortcut to next stage for testing
      //TECL_TenderAdditionalInformation.ContinueToNextStage();

      var saveData = TECL_TenderAdditionalInformation.SerialisedData();
      var cacheId = $("#cacheId").val();

      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/Tender/GetAdditionalInfoContinueDialog",
        type: "POST",
        data: {
          launchStageNext: launchStageNext,
          cacheId: cacheId,
          saveData: saveData
        },
        error: function (exc) {
          TECL_Master.ClearLock("TECL_TenderAdditionalInformation.ShowContinueDialog");
        },
        success: function (partialViewHtml) {
          TECL_Master.ClearLock("TECL_TenderAdditionalInformation.ShowContinueDialog");
          if (partialViewHtml) {
            $("#tenderAdditionalInfoContinueDialog").empty();
            $("#tenderAdditionalInfoContinueDialog").html(partialViewHtml);
            $("#additionalDataConfirmDialog").modal("show");
          }
        }
      });
    }
  },

  // Continue to the next stage
  ContinueToNextStage: function () {
    $("#additionalDataConfirmDialog").modal("hide");
    $("#errNoCustQuestionText").addClass("hidden");
    var cacheId = $("#cacheId").val();

    if (TECL_Master.AddLock("ContinueNextStageUserInformation")) {
      var saveData = TECL_TenderAdditionalInformation.SerialisedData();
      TECL_TenderGeneral.DisplayPleaseWaitDlg();

      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/Tender/ContinueNextStageUserInformation",
        type: "POST",
        data: {
          cacheId: cacheId,
          saveData: saveData
        },
        error: function (exc) {
          TECL_Master.ClearLock("ContinueNextStageUserInformation");
        },
        success: function (partialViewHtml) {
          TECL_Master.ClearLock("ContinueNextStageUserInformation");
          if (partialViewHtml) {
            $("#tenderPage").html(partialViewHtml);
          }
        }
      });
    }
  },

  // Get the Serialised Data
  SerialisedData: function () {

    var defaultQuestionIds = [];
    $(".defaultQuestionListItem").each(function () {
      var checkedBox = $(this).find("[name='DefaultQuestion']");

      if (checkedBox) {
        var checked = $(checkedBox).is(":checked");

        if (checked) {
          var value = checkedBox.data("defaultquestionid");

          if (value) {
            defaultQuestionIds.push(value);
          }
        }
      }
    });

    var customQuestions = [];
    $(".customQuestionListItem").each(function () {
      var questionId = $(this).find("[name='CustomQuestionId']").val();
      var questionText = $(this).find("[name='customQuestionText']").text();

      if (questionText) {
        var customQuestion = {
          Id: questionId,
          QuestionText: questionText
        }

        customQuestions.push(customQuestion);
      }
    });

    var newQuestionText = $("#newCustomeQuestionText").val();
    if (newQuestionText.length > 0) {
      customQuestions.push({
        Id: null,
        QuestionText: newQuestionText
      });
    }

    // Get the ratings data
    var ratings = TECL_TenderAdditionalInformation.SerialiseRatings();

    var supplierText = "";
    var $supplierTextNode = $("#supplierTextVal");
    if ($supplierTextNode && $supplierTextNode.length > 0) {
      supplierText = $supplierTextNode.val();
    }

    var saveData = {
      DefaultQuestionIds: defaultQuestionIds,
      CustomQuestions: customQuestions,
      SupplierText: supplierText,
      Ratings: ratings
    }
    return saveData;
  },

  /*
   * Get the amount of ratings on the additional information
   */
  GetRatingsCount: function() {
    var count = 0;
    $(".bubble-rating-control .bubble-row .bubble-col input:visible").each(function () {
      if ($(this).val()) {
        count++;
      }
    });
    return count;
  },

  /*
   * Method used to serialise the ratings
   */
  SerialiseRatings: function() {
    var ratings = [];
    var count = 0;
    $(".bubble-rating-control .bubble-row:visible").each(function () {
      var $row = $(this);
      var $input = $row.find("input");
      var inputValue = $input.val();

      if (inputValue) {

        var weighting = parseInt($row.find(".bubble-item.bubble-enabled:visible").attr("data-bubbleIndex"));
        var fieldId = $row.attr("data-metaFieldId");

        ratings.push({
          SortOrder: count++,
          MetaDataFieldId: fieldId,
          CustomRatingText: inputValue,
          Weighting: weighting
        });
      }
    });
    return ratings;
  }

};